import { render, staticRenderFns } from "./LmColorPickerBuilderUi.vue?vue&type=template&id=22c8dfbe"
import script from "./LmColorPickerBuilderUi.vue?vue&type=script&lang=js"
export * from "./LmColorPickerBuilderUi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports